/* Copyright (c) 2019-2023 VMware, Inc. All rights reserved. VMware Confidential */
import { Event } from "@app/services/dispatcher/events/event";
import { TaskV2 } from "@api/generated/vcdr";
import { HttpErrorResponse } from "@angular/common/http";

export class ErrorOccurredEvent extends Event {
    public static ID: string = "ERROR_OCCURRED";

    public httpError: HttpErrorResponse;
    public task: TaskV2;
    public isNew: boolean = true;

    private constructor() {
        super(ErrorOccurredEvent.ID);
    }

    static fromTask(task: TaskV2, isNew: boolean = true): ErrorOccurredEvent {
        const result: ErrorOccurredEvent = new ErrorOccurredEvent();
        result.task = task;
        result.isNew = isNew;
        return result;
    }

    static fromHttpError(error: HttpErrorResponse): ErrorOccurredEvent {
        const result: ErrorOccurredEvent = new ErrorOccurredEvent();
        result.httpError = error;
        return result;
    }
}
